import { Button, Row } from "antd";
import { Link, NavigateFunction, useNavigate } from "react-router-dom";
import Logo from "../../../components/LoggedInHeader/components/Logo";
import { useLogoRedirectPath } from "../../../lib/hooks/useLogoRedirectPath";
import { CloseOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { Steps } from "./Steps";

type HeaderProps = {
  step: number;
};

export const Header = ({ step }: HeaderProps) => {
  const { logoRedirectPath } = useLogoRedirectPath();

  const navigate: NavigateFunction = useNavigate();

  const onClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <Row className="justify-space-between px-8 py-4 header">
      <Row className="justify-space-between w-100 mb-4">
        <Link to={logoRedirectPath} id={logoRedirectPath}>
          <Logo />
        </Link>
        <Button shape="circle" icon={<CloseOutlined />} onClick={onClose} />
      </Row>
      <Row className="w-100 justify-center">
        <Steps step={step} />
      </Row>
    </Row>
  );
};
